import {AssetType} from '@hconnect/common/types'
import React, {useLayoutEffect} from 'react'
import {useNavigate} from 'react-router'

import {SettingsDetailsSkeleton} from '../../common/components'

import {AssetDetails} from './AssetDetails'

import {useAssetsQuery} from '@settings/modules/common/hooks'
import {PLANT_ROUTES, getUrl, useUrlParam} from '@settings/modules/routing'

export const PageAsset: React.FC = () => {
  const {data: assets} = useAssetsQuery({sorted: true})
  const plantCode = useUrlParam('plantCode')
  const assetId = useUrlParam('assetId')
  const navigate = useNavigate()

  const isAssetIdValid = !!assets?.find((asset) => asset.id === Number(assetId))

  const firstAssetId = assets?.[0]?.id
  useLayoutEffect(() => {
    if (!isAssetIdValid) {
      navigate(
        getUrl(PLANT_ROUTES.ASSETS.ASSET_TYPE.ID.path, {
          plantCode,
          assetType: AssetType.CementMill,
          assetId: String(firstAssetId)
        })
      )
    }
  }, [isAssetIdValid, navigate, plantCode, firstAssetId])

  if (!isAssetIdValid) {
    return <SettingsDetailsSkeleton numberOfCards={3} />
  }

  return <AssetDetails />
}
